<template>
  <div class="min-vh">
    <CRow class="no-gutters px-3 px-sm-0 mb-2">
      <b-col
        sm="6"
        class="text-center text-sm-left mb-sm-0 d-flex align-items-center"
      >
        <h1 class="mr-3 mb-0 header-main text-uppercase">IN CONVERSATION</h1>
        <font-awesome-icon
          icon="sync-alt"
          class="icon-sync"
          @click="getAllData"
        />
      </b-col>
    </CRow>
    <div>
      <div>
        <b-container class="px-0 bg-white-border main-theme">
          <div class="p-3">
            <div class="mb-3">
              <b-row class="no-gutters">
                <b-col cols="12" sm>
                  <div class="m-0 mb-4 mb-sm-0 mr-sm-2 stat-container">
                    <p>Avg. Wait Time</p>
                    <span class="number">{{
                      secsToTime(widgetData.avgWaitTimeSec)
                    }}</span>
                  </div>
                </b-col>
                <b-col cols="12" sm>
                  <div class="mr-0 mb-4 mb-sm-0 mr-sm-2 stat-container">
                    <p>Total Waiting Customer</p>
                    <span class="number">{{
                      widgetData.totalWaiting | numeral("0,0")
                    }}</span>
                  </div>
                </b-col>
                <b-col cols="12" sm="3">
                  <div class="mr-0 mb-4 mb-sm-0 mr-sm-2 stat-container">
                    <p>Total In Conversation Customer</p>
                    <span class="number">{{
                      widgetData.totalInConversation | numeral("0,0")
                    }}</span>
                  </div>
                </b-col>
                <b-col cols="12" sm="2">
                  <div class="mr-0 mb-4 mb-sm-0 mr-sm-2 stat-container">
                    <p>Total My Case</p>
                    <span class="number">{{
                      widgetData.totalMyCase | numeral("0,0")
                    }}</span>
                  </div>
                </b-col>
                <b-col cols="12" sm="2">
                  <div class="mr-0 mb-4 mb-sm-0 stat-container">
                    <p>Total My Pending</p>
                    <span class="number">{{
                      widgetData.totalMyPending | numeral("0,0")
                    }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>

            <b-row class="no-gutters">
              <b-col cols="12">
                <div class="h-100">
                  <div class="mb-2 d-flex justify-content-between">
                    <strong
                      >Waiting Customer
                      <span class="badge badge-main badge-pill">
                        {{ waitCustomer.rows | numeral("0,0") }}
                      </span>
                    </strong>
                  </div>
                  <b-table
                    responsive
                    striped
                    hover
                    class="table-list hide-icon-sort"
                    :items="waitCustomer.items"
                    :fields="waitCustomer.fields"
                    :busy="waitCustomer.isBusy"
                    show-empty
                    :empty-text="$t('noData')"
                    :sort-by.sync="waitCustomer.sortBy"
                    :sort-desc.sync="waitCustomer.sortDesc"
                  >
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                    <template #head()="data">
                      <span>{{ data.label }}</span>
                      <font-awesome-icon
                        v-if="data.field.sortable"
                        icon="sort-up"
                        class="sort-icon up"
                      />
                      <font-awesome-icon
                        v-if="data.field.sortable"
                        icon="sort-down"
                        class="sort-icon down"
                      />
                    </template>
                    <template v-slot:cell(userGUID)="data">
                      <div class="d-flex align-items-center">
                        <div class="img-customer mr-3">
                          <b-img
                            v-if="data.item.customerImageurl"
                            :src="data.item.customerImageurl"
                            blank-color="#8a93a2"
                            rounded="circle"
                            @error="replaceByDefault"
                          />
                          <b-avatar v-else size="40px"></b-avatar>
                        </div>
                        <div>
                          <div class="text-left">
                            {{ data.item.customerName }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(channel)="data">
                      <div class="tag-social">
                        <img
                          :src="channelList[data.item.chanelId].imageUrl"
                          alt=""
                        /><span class="mb-0 text-left">{{
                          data.item.platformConfigName
                        }}</span>
                      </div>
                    </template>
                    <template v-slot:cell(waitTimeSecond)="data">
                      <span>
                        {{ data.item.waitTime }}
                      </span>
                    </template>
                  </b-table>
                  <b-row class="no-gutters">
                    <b-col
                      class="form-inline justify-content-center justify-content-sm-between"
                    >
                      <div v-if="waitCustomer.rows > 0" class="my-3">
                        Showing {{ waitCustomer.startPage | numeral("0,0") }} to
                        {{ waitCustomer.endPage | numeral("0,0") }} of
                        {{ waitCustomer.rows | numeral("0,0") }} entires
                      </div>
                      <div v-else class="my-3">
                        {{ waitCustomer.rows }} entire
                      </div>
                      <div class="d-sm-flex m-3">
                        <b-pagination
                          v-model="waitCustomer.filter.pageNo"
                          :total-rows="waitCustomer.rows"
                          :per-page="waitCustomer.filter.perPage"
                          class="m-md-0"
                          @change="(val) => pagination(val, 'waitCustomer')"
                          align="center"
                        ></b-pagination>
                        <b-form-select
                          class="select-pagination ml-md-3 w-auto"
                          v-model="waitCustomer.filter.perPage"
                          @change="
                            (val) => handleChangePerpage(val, 'waitCustomer')
                          "
                          :options="pageOptions"
                        ></b-form-select>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <hr />
            <b-row class="no-gutters">
              <b-col cols="12">
                <div class="h-100">
                  <div class="mb-2 d-flex justify-content-between">
                    <strong
                      >In Conversation
                      <span class="badge badge-main badge-pill">
                        {{ inConversation.rows | numeral("0,0") }}
                      </span>
                    </strong>
                  </div>
                  <b-table
                    responsive
                    striped
                    hover
                    class="table-list hide-icon-sort"
                    :items="inConversation.items"
                    :fields="inConversation.fields"
                    :busy="inConversation.isBusy"
                    show-empty
                    :empty-text="$t('noData')"
                    :sort-by.sync="inConversation.sortBy"
                    :sort-desc.sync="inConversation.sortDesc"
                  >
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                    <template #head()="data">
                      <span>{{ data.label }}</span>
                      <font-awesome-icon
                        v-if="data.field.sortable"
                        icon="sort-up"
                        class="sort-icon up"
                      />
                      <font-awesome-icon
                        v-if="data.field.sortable"
                        icon="sort-down"
                        class="sort-icon down"
                      />
                    </template>
                    <template v-slot:cell(userGUID)="data">
                      <div class="d-flex align-items-center">
                        <div class="img-customer mr-3">
                          <b-img
                            v-if="data.item.customerImageurl"
                            :src="data.item.customerImageurl"
                            blank-color="#8a93a2"
                            rounded="circle"
                            @error="replaceByDefault"
                          />
                          <b-avatar v-else size="40px"></b-avatar>
                        </div>
                        <div>
                          <div class="text-left">
                            {{ data.item.customerName }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(channel)="data">
                      <div class="tag-social">
                        <img
                          :src="channelList[data.item.chanelId].imageUrl"
                          alt=""
                        /><span class="mb-0 text-left">{{
                          data.item.platformConfigName
                        }}</span>
                      </div>
                    </template>
                    <template v-slot:cell(agentName)="data">
                      <span>
                        {{ data.item.agentName }}
                      </span>
                    </template>
                    <template v-slot:cell(inconversationTimeSecond)="data">
                      <span>
                        {{ data.item.inconversationTime }}
                      </span>
                    </template>
                  </b-table>
                  <b-row class="no-gutters">
                    <b-col
                      class="form-inline justify-content-center justify-content-sm-between"
                    >
                      <div v-if="inConversation.rows > 0" class="my-3">
                        Showing
                        {{ inConversation.startPage | numeral("0,0") }} to
                        {{ inConversation.endPage | numeral("0,0") }} of
                        {{ inConversation.rows | numeral("0,0") }} entires
                      </div>
                      <div v-else class="my-3">
                        {{ inConversation.rows }} entire
                      </div>
                      <div class="d-sm-flex m-3">
                        <b-pagination
                          v-model="inConversation.filter.pageNo"
                          :total-rows="inConversation.rows"
                          :per-page="inConversation.filter.perPage"
                          class="m-md-0"
                          @change="(val) => pagination(val, 'inConversation')"
                          align="center"
                        ></b-pagination>
                        <b-form-select
                          class="select-pagination ml-md-3 w-auto"
                          v-model="inConversation.filter.perPage"
                          @change="
                            (val) => handleChangePerpage(val, 'inConversation')
                          "
                          :options="pageOptions"
                        ></b-form-select>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <hr />
            <b-row class="no-gutters">
              <b-col cols="12">
                <div class="h-100">
                  <div class="mb-2 d-flex justify-content-between">
                    <strong>
                      All Agent
                      <span class="badge badge-main badge-pill">
                        {{ allAgent.rows | numeral("0,0") }}
                      </span>
                      <span class="active-agent">
                        <font-awesome-icon icon="circle" />
                        <span class="mx-1"
                          >Active Agent :
                          {{ widgetData.totalActiveAgent | numeral("0,0") }}
                        </span>
                      </span>
                    </strong>
                  </div>
                  <b-table
                    responsive
                    striped
                    hover
                    class="table-list hide-icon-sort"
                    :items="allAgent.items"
                    :fields="allAgent.fields"
                    :busy="allAgent.isBusy"
                    show-empty
                    :empty-text="$t('noData')"
                    :sort-by.sync="allAgent.sortBy"
                    :sort-desc.sync="allAgent.sortDesc"
                  >
                    <template v-slot:table-busy>
                      <div class="text-center text-black my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-2">Loading...</strong>
                      </div>
                    </template>
                    <template #head()="data">
                      <span>{{ data.label }}</span>
                      <font-awesome-icon
                        v-if="data.field.sortable"
                        icon="sort-up"
                        class="sort-icon up"
                      />
                      <font-awesome-icon
                        v-if="data.field.sortable"
                        icon="sort-down"
                        class="sort-icon down"
                      />
                    </template>
                    <template v-slot:cell(userGUID)="data">
                      <div class="d-flex align-items-center">
                        <div class="img-customer mr-3">
                          <b-avatar
                            :text="data.item.agentName.charAt(0)"
                            size="40px"
                          ></b-avatar>
                        </div>
                        <div>
                          <div class="text-left">
                            {{ data.item.agentName }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(totalCustomer)="data">
                      <span>
                        {{ data.item.totalCustomer | numeral("0,0") }}
                      </span>
                    </template>
                    <template v-slot:cell(myCase)="data">
                      <span>
                        {{ data.item.myCase | numeral("0,0") }}
                      </span>
                    </template>
                    <template v-slot:cell(pending)="data">
                      <span>
                        {{ data.item.pending | numeral("0,0") }}
                      </span>
                    </template>
                  </b-table>
                  <b-row class="no-gutters">
                    <b-col
                      class="form-inline justify-content-center justify-content-sm-between"
                    >
                      <div v-if="allAgent.rows > 0" class="my-3">
                        Showing {{ allAgent.startPage | numeral("0,0") }} to
                        {{ allAgent.endPage | numeral("0,0") }} of
                        {{ allAgent.rows | numeral("0,0") }} entires
                      </div>
                      <div v-else class="my-3">{{ allAgent.rows }} entire</div>
                      <div class="d-sm-flex m-3">
                        <b-pagination
                          v-model="allAgent.filter.pageNo"
                          :total-rows="allAgent.rows"
                          :per-page="allAgent.filter.perPage"
                          class="m-md-0"
                          @change="(val) => pagination(val, 'allAgent')"
                          align="center"
                        ></b-pagination>
                        <b-form-select
                          class="select-pagination ml-md-3 w-auto"
                          v-model="allAgent.filter.perPage"
                          @change="
                            (val) => handleChangePerpage(val, 'allAgent')
                          "
                          :options="pageOptions"
                        ></b-form-select>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import defaultImg from "@/assets/images/icons/blank.png";

export default {
  components: {},
  data: function () {
    return {
      widgetData: {
        activeUser: 0,
        botKnowledge: 0,
        newUser: 0,
      },
      waitCustomer: {
        fields: [
          {
            key: "userGUID",
            label: "Customer",
            sortable: true,
            thClass: "pl-th-profile",
            tdClass: "pl-profile",
          },
          {
            key: "channel",
            label: "Channel",
            class: "col-3",
            sortable: true,
          },
          {
            key: "agentName",
            label: "Agent Name",
            class: "col-3",
            sortable: true,
          },
          {
            key: "waitTimeSecond",
            label: "Wait Time",
            class: "col-4",
            sortable: true,
          },
        ],
        filter: {
          pageNo: 1,
          perPage: 10,
          Search: "",
          sortById: 6,
        },
        isBusy: false,
        rows: 0,
        startPage: 1,
        endPage: 10,
        items: [],
        sortBy: "waitTimeSecond",
        sortDesc: true,
      },
      inConversation: {
        fields: [
          {
            key: "userGUID",
            label: "Customer",
            sortable: true,
            thClass: "pl-th-profile",
            tdClass: "pl-profile",
          },
          {
            key: "channel",
            label: "Channel",
            class: "col-3",
            sortable: true,
          },
          {
            key: "agentName",
            label: "Agent Name",
            class: "col-3",
            sortable: true,
          },
          {
            key: "inconversationTimeSecond",
            label: "In Conversation Time",
            class: "col-4",
            sortable: true,
          },
        ],
        filter: {
          pageNo: 1,
          perPage: 10,
          Search: "",
          sortById: 8,
        },
        isBusy: false,
        rows: 0,
        startPage: 1,
        endPage: 10,
        items: [],
        sortBy: "inconversationTimeSecond",
        sortDesc: true,
      },
      allAgent: {
        fields: [
          {
            key: "userGUID",
            label: "Agent",
            sortable: true,
            thClass: "pl-th-profile",
            tdClass: "pl-profile",
          },
          {
            key: "totalCustomer",
            label: "Total Customer",
            class: "w-80px",
            sortable: true,
          },
          {
            key: "myCase",
            label: "My Case",
            class: "w-80px",
            sortable: true,
          },
          {
            key: "pending",
            label: "Pending",
            class: "w-80px",
            sortable: true,
          },
        ],
        filter: {
          pageNo: 1,
          perPage: 10,
          Search: "",
          sortById: 4,
        },
        isBusy: false,
        rows: 0,
        startPage: 1,
        endPage: 10,
        items: [],
        sortBy: "totalCustomer",
        sortDesc: true,
      },
      msgModal: null,
      modalMessage: "",
      channelList: {},
      interval: null,
      time: 5000,
      widgetData: {
        avgWaitTimeSec: 0,
        totalWaiting: 0,
        totalInConversation: 0,
        totalMyCase: 0,
        totalMyPending: 0,
      },
      pageOptions: [
        { value: 10, text: `10 / Page` },
        { value: 30, text: `30 / Page` },
        { value: 50, text: `50 / Page` },
        { value: 100, text: `100 / Page` },
      ],
    };
  },
  mounted: async function () {
    await this.getChannel();
    await this.getAllData();
    // this.interval = setInterval(async () => {
    //   await this.getAllData();
    // }, this.time);
  },
  // beforeDestroy() {
  //   clearInterval(this.interval);
  // },
  watch: {
    "waitCustomer.sortBy"(newValue, oldValue) {
      this.handleSorting("waitCustomer", newValue);
    },
    "waitCustomer.sortDesc"(newValue, oldValue) {
      this.handleSorting("waitCustomer", this.waitCustomer.sortBy, newValue);
    },
    "inConversation.sortBy"(newValue, oldValue) {
      this.handleSorting("inConversation", newValue);
    },
    "inConversation.sortDesc"(newValue, oldValue) {
      this.handleSorting(
        "inConversation",
        this.inConversation.sortBy,
        newValue
      );
    },
    "allAgent.sortBy"(newValue, oldValue) {
      this.handleSorting("allAgent", newValue);
    },
    "allAgent.sortDesc"(newValue, oldValue) {
      this.handleSorting("allAgent", this.allAgent.sortBy, newValue);
    },
  },
  methods: {
    async handleSorting(key, sortBy, sortDesc = false) {
      if (key == "waitCustomer") {
        if (sortBy == "userGUID") {
          this[key].filter.sortById = sortDesc ? 2 : 1;
        } else if (sortBy == "channel") {
          this[key].filter.sortById = sortDesc ? 4 : 3;
        } else if (sortBy == "waitTimeSecond") {
          this[key].filter.sortById = sortDesc ? 6 : 5;
        } else if (sortBy == "agentName") {
          this[key].filter.sortById = sortDesc ? 8 : 7;
        }
        await this.getWaitCustomer();
      } else if (key == "inConversation") {
        if (sortBy == "userGUID") {
          this[key].filter.sortById = sortDesc ? 2 : 1;
        } else if (sortBy == "channel") {
          this[key].filter.sortById = sortDesc ? 4 : 3;
        } else if (sortBy == "agentName") {
          this[key].filter.sortById = sortDesc ? 6 : 5;
        } else if (sortBy == "inconversationTimeSecond") {
          this[key].filter.sortById = sortDesc ? 8 : 7;
        }
        await this.getInConversation();
      } else if (key == "allAgent") {
        if (sortBy == "userGUID") {
          this[key].filter.sortById = sortDesc ? 2 : 1;
        } else if (sortBy == "totalCustomer") {
          this[key].filter.sortById = sortDesc ? 4 : 3;
        } else if (sortBy == "myCase") {
          this[key].filter.sortById = sortDesc ? 6 : 5;
        } else if (sortBy == "pending") {
          this[key].filter.sortById = sortDesc ? 8 : 7;
        }
        await this.getAllAgent();
      }
    },
    getAllData: async function () {
      await this.getWidget();
      await this.getWaitCustomer();
      await this.getInConversation();
      await this.getAllAgent();
    },
    getWidget: async function () {
      const url = `${this.$baseUrl}/analytics/realTime/GetAvg`;
      await this.axios.get(url).then((data) => {
        if (data.result === 1) {
          this.widgetData = data.detail;
        }
      });
    },
    getWaitCustomer: async function () {
      this.waitCustomer.isBusy = true;
      const url = `${this.$baseUrl}/analytics/RealTime/GetWaitCustomer`;
      await this.axios
        .post(url, this.waitCustomer.filter)
        .then((data) => {
          if (data.result === 1) {
            this.waitCustomer.items = data.detail.data;
            this.waitCustomer.rows = data.detail.count;
            this.waitCustomer.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getInConversation: async function () {
      this.inConversation.isBusy = true;
      const url = `${this.$baseUrl}/analytics/RealTime/GetInConversation`;
      await this.axios
        .post(url, this.inConversation.filter)
        .then((data) => {
          if (data.result === 1) {
            this.inConversation.items = data.detail.data;
            this.inConversation.rows = data.detail.count;
            this.inConversation.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllAgent: async function () {
      this.allAgent.isBusy = true;
      const url = `${this.$baseUrl}/analytics/RealTime/GetAllAgent`;
      await this.axios
        .post(url, this.allAgent.filter)
        .then((data) => {
          if (data.result === 1) {
            this.allAgent.items = data.detail.data;
            this.allAgent.rows = data.detail.count;
            this.allAgent.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getChannel: async function () {
      const url = `${this.$baseUrl}/analytics/Filter/Channel`;
      await this.axios.get(url).then(async (data) => {
        if (data.result === 1) {
          await data.detail.forEach((item) => {
            this.channelList[item.id] = item;
          });
        }
      });
    },
    replaceByDefault(e) {
      e.target.src = defaultImg;
    },
    async pagination(page, keyType) {
      this[keyType].filter.pageNo = page;
      if (keyType == "waitCustomer") await this.getWaitCustomer();
      else if (keyType == "inConversation") await this.getInConversation();
      else if (keyType == "allAgent") await this.getAllAgent();
      this.getShowingPage(page, keyType);
    },
    async handleChangePerpage(perPage, keyType) {
      this[keyType].filter.pageNo = 1;
      this[keyType].filter.perPage = perPage;
      if (keyType == "waitCustomer") await this.getWaitCustomer();
      else if (keyType == "inConversation") await this.getInConversation();
      else if (keyType == "allAgent") await this.getAllAgent();
      this.getShowingPage(this[keyType].filter.pageNo, keyType);
    },
    async getShowingPage(page, keyType) {
      let result = await this.$getShowingPage(page, this[keyType].filter);
      this[keyType].startPage = result.startPage;
      this[keyType].endPage = result.endPage;
    },
    secsToTime(secs) {
      let d = (secs / 8.64e4) | 0;
      let H = ((secs % 8.64e4) / 3.6e3) | 0;
      let m = ((secs % 3.6e3) / 60) | 0;
      let s = secs % 60;
      // let z = (n) => (n < 10 ? "0" : "") + n;
      let result = "";
      if (d) result += `${d}d `;
      if (H) result += `${H}h `;
      if (m) result += `${m}m `;
      result += `${Math.round(s)}s`;
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.f-size-12 {
  font-size: 12px;
}

.date-container {
  max-width: 35%;
  margin: 0 0.5rem;
}

.row-container {
  border: 1px solid #dedede;
}

.stat-container {
  padding: 1rem;
  // border-radius: 4px;
  background: #e2dff3;
  color: #3c4b64;
  height: 100%;
  border-left: 5px solid #7160c4;
  font-size: 14px;
  .number {
    font-size: 1.5rem;
    font-weight: bold;
  }
}

.header-container {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
::v-deep .input-flex-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  .custom-control-inline {
    width: 43% !important;
  }
}
.img-customer {
  img {
    width: 40px;
    height: 40px;
  }
  // .b-avatar-text {

  // }
}

.badge-main {
  background-color: #e2dff3;
  color: #b41bb4;
  font-size: 14px;
}
.badge-green {
  background-color: #e2dff3;
  color: #27bda7;
  font-size: 14px;
}
::v-deep .pl-profile {
  text-align: left;
  padding-left: 9rem !important;
}
::v-deep .pl-th-profile {
  text-align: left;
  padding-left: 12.5rem !important;
}
.icon-sync {
  color: #b41bb4;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}
.active-agent {
  color: #27bda7;
  margin-left: 10px;
  svg {
    font-size: 8px;
    margin-bottom: 2px;
  }
}
.tag-social {
  -ms-flex-pack: start !important;
  justify-content: start !important;
}
::v-deep .col-2 {
  min-width: 120px !important;
  width: 15% !important;
}
::v-deep .col-3 {
  min-width: 200px !important;
  width: 20% !important;
}
::v-deep .col-4 {
  min-width: 210px !important;
  width: 20% !important;
}
@media (max-width: 720px) {
  .header-container {
    flex-direction: column-reverse;
  }
}
</style>
